import PropTypes from 'prop-types';
/* eslint-disable camelcase */
import { Trans, useTranslation } from 'react-i18next';
import imgNewsletter2531_1 from 'url:../../../../../resource/images/newsletter_2531_1.png';
import imgNewsletter2531_2 from 'url:../../../../../resource/images/newsletter_2531_2.png';
import imgNewsletter2531_3 from 'url:../../../../../resource/images/newsletter_2531_3.png';
import { nsNewsletter } from '@/app/i18n/namespaces';

// Sprint number : 2531
const Sp2531Newsletter230725 = ({ params }) => {
    const { t: translate } = useTranslation(nsNewsletter);
    const elements = { 1: <b />, 2: <b /> };

    return (
        <div className='space-y-4'>
            <div className='space-y-4'>
                <p className='font-semibold text-lg text-primary'>
                    {translate('editions.sp2531.title')}
                </p>
                <p>
                    <Trans t={translate} i18nKey='editions.sp2531.intro' components={{ 1: <b /> }} />
                </p>
                <p><b>{translate('editions.sp2531.howTitle')}</b></p>
                <p></p>
                <ol className='list-decimal ml-8'>
                    <li>{translate('editions.sp2531.step1')}</li>
                    <li><Trans t={translate} i18nKey='editions.sp2531.step2' components={{ 1: <b /> }} /></li>
                    <li><Trans t={translate} i18nKey='editions.sp2531.step3' components={elements} /></li>
                    <li><Trans t={translate} i18nKey='editions.sp2531.step4' components={{ 1: <b /> }} /></li>
                    <li>
                        {translate('editions.sp2531.step5Intro')}
                        <ul className='list-disc ml-8'>
                            <li><Trans t={translate} i18nKey='editions.sp2531.freq_daily' components={{ 1: <b /> }} /></li>
                            <li><Trans t={translate} i18nKey='editions.sp2531.freq_weekly' components={{ 1: <b /> }} /></li>
                            <li><Trans t={translate} i18nKey='editions.sp2531.freq_monthly' components={{ 1: <b /> }} /></li>
                        </ul>
                    </li>
                </ol>
                <p></p>
                <b>{translate('editions.sp2531.important')}</b>
                <ul className='list-disc ml-8'>
                    <li><Trans t={translate} i18nKey='editions.sp2531.imp1' components={elements} /></li>
                    <li><Trans t={translate} i18nKey='editions.sp2531.imp2' components={{ 1: <b /> }} /></li>
                    <li><Trans t={translate} i18nKey='editions.sp2531.imp3' components={{ 1: <b /> }} /></li>
                </ul>
            </div>
            <img onLoad={() => params.handleImageLoad()}
                src={imgNewsletter2531_1} /><br /><br />
            <img onLoad={() => params.handleImageLoad()}
                src={imgNewsletter2531_2} /><br /><br />
            <img onLoad={() => params.handleImageLoad()}
                src={imgNewsletter2531_3} /><br /><br />
        </div>
    );
};

Sp2531Newsletter230725.propTypes = {
    params: PropTypes.shape({
        handleImageLoad: PropTypes.func.isRequired
    }).isRequired
};

export default Sp2531Newsletter230725;
